import { callApi } from "../../utils/common.utils";

export const resetPassword = async (token: string, newPassword: string) => {
  const payLoad = {
    token,
    newPassword,
  };
  return callApi("resetpassword", payLoad, "getData");
};

export const checkToken = async (token: string | null) => {
  const payLoad = {
    token,
  };
  return callApi("checktoken", payLoad, "getData");
};
